export default __webpack_public_path__ + "static/media/new-push-floor.8b24a74d.png";